






































import { Component, Prop, Model, Watch, Vue } from 'vue-property-decorator';
import WordOptionsPopup, { UpdateParameterEvent } from './WordOptionsPopup.vue';
import IntentParameter from './IntentParameter.vue';
import { Param } from './IntentParameter.vue';
import '../directives/v-focus';
// import {VMenu, VCombobox, VList} from 'vuetify/src/components';
// import { MdAutocomplete } from 'vue-material/dist/components';

export interface ManualRecognitionResult {
  utterance: string;
  parameters: {[name: string]: string};
}

/**
 * Supports keyboard navigation:
 *   - left/right select word
 *   - shift-left/right - extend selection
 *   - down to select phrase intent (and optionally domain)
 *
 * mouse/touch and
 * voice commands:
 *   - "next [word]"
 *   - "previous|back [word]"
 *   - "'New York' is a city"
 *   - "intent is TRAVEL"
 *   - "domain is ..."
 */
@Component<TokenisedPhrase>({
  created() {
    this._onMouseMove = this.onMouseMove.bind(this);
    this._onMouseUp = this.onMouseUp.bind(this);
  },
  components: {WordOptionsPopup, IntentParameter}
  // directives: {VFocus}
  // components: {VMenu, VCombobox, VList}
})
export default class TokenisedPhrase extends Vue {

  get classForWord() {
    return this.words!.map((word, i) => {
      return {
        'highlight': i >= this.start! && i <= this.end!,
        'highlight--start': i === this.start,
        'highlight--end': i === this.end,
        'word--ignore': this.ignoredWords[i],
        'word--param': (word as Param).display
      };
    });
  }
  public intent: string | null = '';

  /** eg: 'flights from Sydney to New York today' */
  @Prop() private utterance!: string;
  private index: number = 0;
  private start: number | null = null;
  private end: number | null = null;
  private dragStart: number | null = null;
  private pressTimer?: number;
  // private menu: {x?: number, y?: number, start?: number, end?: number, words?: Array<string | Param>} = null;
  private menu: ({x?: number, y?: number, start?: number, end?: number, words?: Array<string | Param>} | null) = null;
  private words: (Array<string | Param> | null) = [];
  private ignoredWords: {[index: number]: boolean | 'stop'} = {};
  /* tslint:disable variable-name */
  private _onMouseMove!: (($event: any) => void | null);
  private _onMouseUp!: (($event: any) => void | null);

  @Watch('utterance', {immediate: true})
  public onUtterance() {
    console.info('updated utterance');
    this.start = this.end = 0;
    this.ignoredWords = {};
    if (this.utterance) {
        this.words = this.utterance.split(' ');
    } else {
        this.words = null;
    }
    // this.words = this.utterance && this.utterance.split(' ');
  }

/*
  public mounted() {
    const self = this;
    this.$nextTick(function() {
      self.$el.focus();
    });

    // this.onFocus();
  }
*/

  public onFocus() {
    console.info('focus');
    if (this.end! <= 0) {
      this.start = this.end = this.index = 0;
    }
    this.$emit('focus');
  }

  public onBlur() {
    console.info('blur');
    this.start = -1;
    this.end = -1;
    // this.hideMenu();
    this.$emit('blur');
  }

  public onShowMenu($event: any) {
    console.info('onShowMenu');

    if (this.start! >= 0) {
      // const rect = $event.target.getBoundingClientRect();
      this.menu = {
        x: $event.target!.offsetLeft, // rect.x,
        y: $event.target!.offsetTop + $event.target!.offsetHeight, // rect.bottom,
        start: this.start!,
        end: this.end!,
        words: this.words! // .slice(this.start, this.end)
      };
    }
  }

  public onMouseDown($event: any) {
    // $event.preventDefault();
    // $event.stopPropagation();
    (this.$refs.utterance as HTMLElement).focus();

    // show menu on long-touch
    this.pressTimer = window.setTimeout(() => {
      this.onShowMenu($event);
    }, 500);

    const index = indexOfWord($event.target);
    if ($event.shiftKey) {
      // expand/shrink selection
      if (index < this.index) {
        this.start = index;
      } else {
        this.end = index;
      }
    } else {
      this.hideMenu();

      // select the current word, prepare for drag
      if (this.dragStart !== null) {
        console.info('already dragging');
        return;
      }
      this.dragStart = index;

      window.addEventListener('mousemove', this._onMouseMove);
      window.addEventListener('touchmove', this._onMouseMove);
      window.addEventListener('mouseup', this._onMouseUp);
      window.addEventListener('touchend', this._onMouseUp);

      if (this.start === null || index < this.start || this.end! < index) {
        this.start = this.end = this.index = index;
      }
    }
  }

  public onMouseMove($event: Event) {
    if (this.dragStart !== null) {
      const index = indexOfWordTarget($event);

      if (index !== this.dragStart) {
        // don't show menu when dragging
        clearTimeout(this.pressTimer);
      }

      // expand/shrink selection
      if (index >= 0) {
        if (index < this.dragStart) {
          this.start = index;
          this.end = this.dragStart;
        } else if (index > this.dragStart) {
          this.start = this.dragStart;
          this.end = index;
        }
      }
    }
  }

  public onMouseUp($event: Event) {
    clearTimeout(this.pressTimer);
    window.removeEventListener('mousemove', this._onMouseMove);
    window.removeEventListener('mouseup', this._onMouseUp);
    window.removeEventListener('touchmove', this._onMouseMove);
    window.removeEventListener('touchend', this._onMouseUp);

    this.dragStart = null;
    if ($event.type !== 'touchend') {
      if (this.menu) {
        $event.stopPropagation();
        $event.preventDefault();
        return;
      }

      this.index = indexOfWordTarget($event);
    }
  }

  public onUpdateParam($event: UpdateParameterEvent) {
    /*const param = new Param(this.words.slice($event.start, $event.end + 1).join(' '),
                          $event.name, $event.entity, $event.value,
                          'white', '#795548');*/
    const param: Param = {
      display: this.words!.slice($event.start, $event.end + 1).join(' '),
      name: $event.name,
      entity: $event.entity,
      value: $event.value,
      color: 'white',
      background: '#795548',
      toString() {
        return this.display;
      }
    };
    this.words!.splice($event.start, 1 + $event.end - $event.start, param);

    this.emitRecognition();
  }

  public onDeleteParam($event: any) {
    const words = $event.words[$event.start].display.split(' ');
    this.words!.splice($event.start, 1, ...words);

    this.emitRecognition();
  }

  public onIgnoreWord($event: any) {
    const flag = $event.start === $event.end ? 'stop' : true;
    for (let i = $event.start; i <= $event.end; i++) {
      this.$set(this.ignoredWords, i, flag);
    }

    this.emitRecognition();
  }

  public onEditWord($event: any) {
    console.info('edit', $event);
  }

  private hideMenu() {
    this.menu = null; // {};
  }

  private onKeyDown($event: KeyboardEvent & Event) {
    switch ($event.key) {
      case 'ArrowLeft':
        this.hideMenu();
        return this.previousWord($event.shiftKey);
      case 'ArrowRight':
        this.hideMenu();
        return this.nextWord($event.shiftKey);
      /*case 'ArrowDown':
        if (this.mode < 1) {
          this.mode++;
        }
        console.info(this.$refs.combo);
        if (this.mode === 1) {
          (this.$refs.combo as any).focus();
        }
        break;*/
      case 'ArrowUp':
        this.onShowMenu({target: ($event.target as HTMLElement).getElementsByClassName('word')[this.index]});
        $event.preventDefault();
        break;
    }
  }

  private previousWord(shiftKey?: boolean) {
    if (this.index > 0) {
      if (shiftKey) {
        if (this.start === this.index) {
          this.start--;
        } else if (this.end === this.index) {
          this.end--;
        }
        this.index--;
      } else {
        this.start = this.end = --this.index;
      }
    }
  }

  private nextWord(shiftKey?: boolean) {
    if (this.index + 1 < this.words!.length) {
      if (shiftKey) {
        if (this.end === this.index) {
          this.end++;
        } else if (this.start === this.index) {
          this.start++;
        }
        this.index++;
      } else {
        this.start = this.end = ++this.index;
      }
    }
  }

  private emitRecognition() {
    console.info('emitRecognition....');
    /*const result = this.words.map(word => {
      if ((word as Param).name) {
        return `@${(word as Param).entity}:${(word as Param).name}`;
      }
      return word;
    }).join(' ');*/

    const result: ManualRecognitionResult = {
      utterance: '',
      parameters: {}
    };
    for (let i = 0; i < this.words!.length; i++) {
      if (this.ignoredWords[i]) {
          continue;
      }
      const word = this.words![i];

      if (result.utterance !== '') {
        result.utterance += ' ';
      }

      if ((word as Param).name) {
        result.utterance += `@${(word as Param).entity}:${(word as Param).name}`;
        result.parameters[(word as Param).name!] = (word as Param).value!;
      } else {
        result.utterance += word;
      }
    }

    this.$emit('update:recognition', result);
  }
}

function eventTarget($event: any): HTMLElement {
  if ($event.changedTouches) {
    const touch = $event.changedTouches[0];
    return document.elementFromPoint(touch.clientX, touch.clientY) as HTMLElement;
  } else {
    return $event.target;
  }
}

function indexOfWordTarget($event: any) {
  return indexOfWord(eventTarget($event));
}

function indexOfWord(el: HTMLElement) {
  if (el.classList.contains('param')) {
    el = el.parentElement!;
  }

  return  el.classList.contains('word') ? Array.prototype.indexOf.call(el.parentNode!.childNodes, el) : -1;
}
